import React, { useState, useEffect } from 'react';
import {
    empty
} from '__globals/global-functions';
import {
    getJsonContent, getJsonResultCopy,
    setContent
} from "__globals/copy-functions";

import * as GC from '__globals/GLOBAL-CONSTANTS.js';

export const ResultActionButtons = props => {

    // LOCAL VARIABLES
    const [currentResultScreen, setCurrentResultScreen] = useState(undefined);

    const [showActionOne, setShowActionOne] = useState(false);
    const [showActionTwo, setShowActionTwo] = useState(false);
    const [showActionThree, setShowActionThree] = useState(false);

    const [actionOne, setActionOne] = useState('');
    const [valueOne, setValueOne] = useState('');

    const [actionTwo, setActionTwo] = useState('');
    const [valueTwo, setValueTwo] = useState('');

    const [actionThree, setActionThree] = useState('');
    const [valueThree, setValueThree] = useState('');

    /** SET THE CURRENT RESULT SCREEN **/
    useEffect(() => {
        if (!empty(props.promotion)) {
           if ( !empty(props.gameClaim.parameters.resultScreen) ) {
                setCurrentResultScreen( props.gameClaim.parameters.resultScreen );
            }
        }
    }, [props.promotion]);

    /** GET CONTENT ACTIONS AND VALUE FOR THE BUTTONS **/
    useEffect(() => {
        if (!empty(currentResultScreen)) {
            setShowActionOne( currentResultScreen["actionOne"].show );
            setShowActionTwo( currentResultScreen["actionTwo"].show );
            setShowActionThree( currentResultScreen["actionThree"].show );
            setActionOne( currentResultScreen["actionOne"].action);
            setValueOne( currentResultScreen["actionOne"].value);
            setActionTwo( currentResultScreen["actionTwo"].action);
            setValueTwo( currentResultScreen["actionTwo"].value);
            setActionThree( currentResultScreen["actionThree"].action);
            setValueThree( currentResultScreen["actionThree"].value);
        }
    }, [currentResultScreen]);
    useEffect(() => {
        if ( showActionOne && !empty(props.promotion) ) {
            let resultButton1 = getJsonContent(props.promotion, props.jsonKey, "button1", "<h2>DEFAULT BTN 1</h2>", props.entry );
            setContent("result_button_1", resultButton1);
        }
    }, [showActionOne]);
    useEffect(() => {
        if ( showActionTwo && !empty(props.promotion) ) {
            let resultButton2 = getJsonContent(props.promotion, props.jsonKey, "button2", "<h2>DEFAULT BTN 2</h2>", props.entry );
            setContent("result_button_2", resultButton2);
        }
    }, [showActionTwo]);
    useEffect(() => {
        if ( showActionThree && !empty(props.promotion) ) {
            let resultButton3 = getJsonContent(props.promotion, props.jsonKey, "button3", "<h2>DEFAULT BTN 3</h2>", props.entry );
            setContent("result_button_3", resultButton3);
        }
    }, [showActionThree]);
    /** END GET CONTENT ACTIONS AND VALUE FOR THE BUTTONS **/


    const handleActionButton1 = () => {
        props.doAction( actionOne , valueOne );
    }

    const handleActionButton2 = () => {
        props.doAction( actionTwo , valueTwo );
    }

    const handleActionButton3 = () => {
        props.doAction( actionThree , valueThree );
    }


    return (
        <React.Fragment>
            <div id="result_buttons_wrapper">
                {showActionOne && <div id="result_button_1" onClick={handleActionButton1}>Action One</div>}
                {showActionTwo && <div id="result_button_2" onClick={handleActionButton2}>Action Two</div>}
                {showActionThree && <div id="result_button_3" onClick={handleActionButton3}>Action Three</div>}
            </div>
        </React.Fragment>
    );

}